import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Sempre que o token mudar, busca o usuário da API
  useEffect(() => {
    async function fetchUser() {
      if (token) {
        setLoading(true);
        try {
          const { data } = await api.get('/auth/me', {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUser(data);
        } catch (err) {
          setUser(null);
          // Opcional: remova o token inválido para evitar loop de erro
          localStorage.removeItem('token');
          setToken(null);
        }
        setLoading(false);
      } else {
        setUser(null);
        setLoading(false);
      }
    }
    fetchUser();
  }, [token]);

  // Função para login
  const login = async (email, password) => {
    const { data } = await api.post('/login', { email, password });
    localStorage.setItem('token', data.token);
    setToken(data.token);
    // O user será buscado automaticamente pelo useEffect acima
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, setUser, setToken, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  return useContext(AuthContext);
}